import { createContext, useContext, useEffect, useState } from "react";
import { IntegrationF1 } from "../components/integration/IntegrationF1";
import { IntegrationGooglePhotos } from "../components/integration/IntegrationGooglePhotos";
import { IntegrationSpotify } from "../components/integration/IntegrationSpotify";
import { IntegrationWikipedia } from "../components/integration/IntegrationWikipedia";
import { IntegrationX } from "../components/integration/IntegrationX";
import { TIntegration } from "../models/integrations.model";
import { getIntegrations } from "../services/integrations.service";
import { deepCopy } from "../utils/deepCopy";

export const IntegrationList = [
  IntegrationGooglePhotos,
  // IntegrationGoogleCalendar,
  // IntegrationGoogleMaps,
  // IntegrationAppleHealth,
  // IntegrationSamsumgHealth,
  // IntegrationBritishLibrary,
  IntegrationF1,
  // IntegrationFacebook,
  // IntegrationFamilySearch,
  // IntegrationInstagram,
  IntegrationSpotify,
  IntegrationWikipedia,
  IntegrationX,
];

export const IntegrationsContext = createContext<{
  integrations: TIntegration[];
  addIntegration: (data: TIntegration) => void;
  removeIntegration: (data: TIntegration) => void;
}>({
  integrations: [],
  addIntegration: () => {},
  removeIntegration: () => {},
});

export function IntegrationsProvider({ children }: any) {
  const [integrations, setIntegrations] = useState<TIntegration[]>([]);

  useEffect(() => {
    getIntegrations({
      onSuccess: (data) => {
        setIntegrations(data.content);
      },
    });

    const token = PubSub.subscribe("addIntegration", (msg, data) => {
      setIntegrations((prevState) => {
        const copy = deepCopy(prevState);

        copy.push(data);

        return copy;
      });
    });

    return () => {
      PubSub.unsubscribe(token);
    };
  }, []);

  function addIntegration(data: TIntegration) {
    setIntegrations((prevState) => {
      const copy = deepCopy(prevState);

      copy.push(data);
      return copy;
    });
  }

  function removeIntegration(data: TIntegration) {
    setIntegrations((prevState) => {
      const copy = deepCopy(prevState);

      for (let i = 0; i < copy.length; i++) {
        if (copy[i].id == data.id) {
          copy.splice(i, 1);
          break;
        }
      }

      return copy;
    });
  }

  return (
    <IntegrationsContext.Provider
      value={{ integrations, addIntegration, removeIntegration }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
}

export function useIntegrations() {
  const context = useContext(IntegrationsContext);

  return context;
}
